import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import AuthContext from "../../context/AuthContext"; // 請確保路徑正確

function OrgDashboard() {
  const { orgId, adminId } = useParams();
  const [orgData, setOrgData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("dashboard");
  const navigate = useNavigate();
  const { user, logout } = useContext(AuthContext); // 使用AuthContext

  useEffect(() => {
    // 如果有使用Auth系統，優先使用Auth中的數據
    if (user && user.role === "orgAdmin") {
      setOrgData({
        orgId: user.organisationID,
        adminId: user.id,
        orgName: user.orgName,
        adminName: user.name
      });
      setLoading(false);
      return;
    }

    // 否則從路由參數獲取數據
    const fetchOrgData = () => {
      setLoading(true);

      // Organisation lookup table
      const orgDatabase = [
        { orgId: "H48", adminId: "83", orgName: "Swissotel Clark", adminName: "Admin1" },
        { orgId: "H72", adminId: "91", orgName: "Parkinn Clark", adminName: "Admin1" },
        { orgId: "H77", adminId: "64", orgName: "Reef Cebu", adminName: "Admin1" },
        { orgId: "H28", adminId: "68", orgName: "Midas Manila", adminName: "Admin1" },
        { orgId: "H16", adminId: "31", orgName: "Shangri-la Cebu", adminName: "Admin1" },
        { orgId: "H11", adminId: "25", orgName: "Marriott Spa Clark", adminName: "Admin1" },
        { orgId: "S38", adminId: "89", orgName: "Okada Spa", adminName: "Admin1" },
        { orgId: "S69", adminId: "30", orgName: "Swissotel Spa", adminName: "Admin1" },
        { orgId: "S93", adminId: "15", orgName: "Marriott Spa Clark", adminName: "Admin1" }
      ];

      // Find matching organisation
      const matchedOrg = orgDatabase.find(
        org => org.orgId === orgId && org.adminId === adminId
      );

      if (matchedOrg) {
        setTimeout(() => {
          setOrgData(matchedOrg);
          setLoading(false);
        }, 800); // Simulate loading delay
      } else {
        // Handle invalid credentials
        setTimeout(() => {
          navigate("/org/login");
          setLoading(false);
        }, 800);
      }
    };

    fetchOrgData();
  }, [orgId, adminId, navigate, user]);

  const handleLogout = () => {
    if (logout) logout(); // 使用AuthContext的logout函數
    navigate("/org/login");
  };

  // Mock data for dashboard
  const dashboardData = {
    activeSessions: 12,
    totalTreatments: 587,
    todaysTreatments: 24,
    upcomingBookings: 8,
    recentActivity: [
      { time: "09:45 AM", action: "Treatment completed", room: "Suite 5", therapyType: "Aromatherapy" },
      { time: "11:30 AM", action: "New booking", room: "Suite 2", therapyType: "Deep Tissue" },
      { time: "01:15 PM", action: "Treatment started", room: "Suite 3", therapyType: "Relaxation" },
      { time: "02:30 PM", action: "Session extended", room: "Suite 1", therapyType: "Aromatherapy" }
    ]
  };

  if (loading) {
    return (
      <div style={styles.loadingContainer}>
        <div style={styles.loadingSpinner}></div>
        <p style={styles.loadingText}>Loading organization data...</p>
      </div>
    );
  }

  // 檢查orgData是否存在
  if (!orgData) {
    return (
      <div style={styles.errorContainer}>
        <h2 style={styles.errorTitle}>Organization Not Found</h2>
        <p style={styles.errorText}>Unable to load organization data. Please try again.</p>
        <button
          style={styles.errorButton}
          onClick={() => navigate("/org/login")}
        >
          Return to Login
        </button>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.sidebar}>
        <div style={styles.logoContainer}>
          <div style={styles.logoCircle}>
            <span style={styles.logoText}>KL</span>
          </div>
          <h3 style={styles.brandName}>KAT LAI Technology</h3>
        </div>

        <div style={styles.menuContainer}>
          <div
            style={activeTab === "dashboard" ? { ...styles.menuItem, ...styles.activeMenuItem } : styles.menuItem}
            onClick={() => setActiveTab("dashboard")}
          >
            <span style={styles.menuIcon}>📊</span>
            <span style={styles.menuText}>Dashboard</span>
          </div>

          <div
            style={activeTab === "treatments" ? { ...styles.menuItem, ...styles.activeMenuItem } : styles.menuItem}
            onClick={() => setActiveTab("treatments")}
          >
            <span style={styles.menuIcon}>💆</span>
            <span style={styles.menuText}>Treatments</span>
          </div>

          <div
            style={activeTab === "reports" ? { ...styles.menuItem, ...styles.activeMenuItem } : styles.menuItem}
            onClick={() => setActiveTab("reports")}
          >
            <span style={styles.menuIcon}>📈</span>
            <span style={styles.menuText}>Reports</span>
          </div>

          <div
            style={activeTab === "settings" ? { ...styles.menuItem, ...styles.activeMenuItem } : styles.menuItem}
            onClick={() => setActiveTab("settings")}
          >
            <span style={styles.menuIcon}>⚙️</span>
            <span style={styles.menuText}>Settings</span>
          </div>
        </div>

        <div style={styles.logoutContainer}>
          <div style={styles.menuItem} onClick={handleLogout}>
            <span style={styles.menuIcon}>🚪</span>
            <span style={styles.menuText}>Logout</span>
          </div>
        </div>
      </div>

      <div style={styles.mainContent}>
        <div style={styles.header}>
          <div style={styles.pageTitle}>
            <h1 style={styles.organizationName}>{orgData.orgName}</h1>
            <p style={styles.welcomeText}>Welcome back, {orgData.adminName}</p>
          </div>

          <div style={styles.userInfo}>
            <div style={styles.notification}>
              <span style={styles.notificationIcon}>🔔</span>
              <span style={styles.notificationBadge}>3</span>
            </div>
            <div style={styles.userProfile}>
              <div style={styles.userAvatar}>{orgData.adminName.charAt(0)}</div>
              <div style={styles.userDetails}>
                <p style={styles.userName}>{orgData.adminName}</p>
                <p style={styles.userRole}>Administrator</p>
              </div>
            </div>
          </div>
        </div>

        <div style={styles.dashboardContent}>
          <div style={styles.statCards}>
            <div style={styles.statCard}>
              <h3 style={styles.statTitle}>Active Sessions</h3>
              <p style={styles.statValue}>{dashboardData.activeSessions}</p>
              <p style={styles.statInfo}>3 more than yesterday</p>
            </div>

            <div style={styles.statCard}>
              <h3 style={styles.statTitle}>Total Treatments</h3>
              <p style={styles.statValue}>{dashboardData.totalTreatments}</p>
              <p style={styles.statInfo}>Lifetime treatments</p>
            </div>

            <div style={styles.statCard}>
              <h3 style={styles.statTitle}>Today's Treatments</h3>
              <p style={styles.statValue}>{dashboardData.todaysTreatments}</p>
              <p style={styles.statInfo}>75% complete</p>
            </div>

            <div style={styles.statCard}>
              <h3 style={styles.statTitle}>Upcoming Bookings</h3>
              <p style={styles.statValue}>{dashboardData.upcomingBookings}</p>
              <p style={styles.statInfo}>Next 24 hours</p>
            </div>
          </div>

          <div style={styles.recentActivity}>
            <h2 style={styles.sectionTitle}>Recent Activity</h2>
            <div style={styles.activityList}>
              {dashboardData.recentActivity.map((activity, index) => (
                <div key={index} style={styles.activityItem}>
                  <div style={styles.activityTime}>{activity.time}</div>
                  <div style={styles.activityDetails}>
                    <p style={styles.activityAction}>{activity.action}</p>
                    <p style={styles.activityInfo}>
                      {activity.room} • {activity.therapyType}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div style={styles.quickActions}>
            <h2 style={styles.sectionTitle}>Quick Actions</h2>
            <div style={styles.actionButtons}>
              <button style={styles.actionButton}>
                <span style={styles.actionIcon}>➕</span>
                <span style={styles.actionText}>New Treatment</span>
              </button>

              <button style={styles.actionButton}>
                <span style={styles.actionIcon}>📝</span>
                <span style={styles.actionText}>Create Report</span>
              </button>

              <button style={styles.actionButton}>
                <span style={styles.actionIcon}>🔍</span>
                <span style={styles.actionText}>View Analytics</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const keyframes = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
  }
  
  @keyframes pulse {
    0% { box-shadow: 0 0 0 0 rgba(141, 110, 99, 0.4); }
    70% { box-shadow: 0 0 0 10px rgba(141, 110, 99, 0); }
    100% { box-shadow: 0 0 0 0 rgba(141, 110, 99, 0); }
  }
`;

const styles = {
  container: {
    display: "flex",
    minHeight: "100vh",
    fontFamily: "'Cormorant Garamond', 'Playfair Display', 'Baskerville', serif",
    backgroundColor: "#f9f5f1",
  },
  loadingContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    width: "100%",
    backgroundColor: "#f9f5f1",
  },
  loadingSpinner: {
    width: "40px",
    height: "40px",
    border: "4px solid rgba(141, 110, 99, 0.2)",
    borderRadius: "50%",
    borderTopColor: "#8d6e63",
    animation: "spin 1s linear infinite",
    marginBottom: "20px",
  },
  loadingText: {
    color: "#8d6e63",
    fontSize: "16px",
    fontWeight: "500",
    letterSpacing: "0.5px",
  },
  sidebar: {
    width: "250px",
    backgroundColor: "#f0e6d9",
    color: "#6d4c41",
    display: "flex",
    flexDirection: "column",
    boxShadow: "2px 0 10px rgba(0, 0, 0, 0.05)",
    zIndex: 10,
    padding: "20px 0",
    borderRight: "1px solid rgba(141, 110, 99, 0.1)",
  },
  logoContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    borderBottom: "1px solid rgba(141, 110, 99, 0.1)",
  },
  logoCircle: {
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    backgroundColor: "#8d6e63",
    background: "linear-gradient(135deg, #a1887f, #8d6e63)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 4px 10px rgba(141, 110, 99, 0.3)",
    marginBottom: "10px",
  },
  logoText: {
    color: "#f5f0ec",
    fontWeight: "bold",
    fontSize: "20px",
    letterSpacing: "1px",
  },
  brandName: {
    margin: "5px 0 0 0",
    fontSize: "16px",
    fontWeight: "600",
    color: "#6d4c41",
    letterSpacing: "0.5px",
  },
  menuContainer: {
    flex: 1,
    padding: "20px 0",
  },
  menuItem: {
    display: "flex",
    alignItems: "center",
    padding: "12px 20px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    borderLeft: "4px solid transparent",
  },
  activeMenuItem: {
    backgroundColor: "rgba(141, 110, 99, 0.1)",
    borderLeftColor: "#8d6e63",
  },
  menuIcon: {
    marginRight: "15px",
    fontSize: "18px",
  },
  menuText: {
    fontSize: "15px",
    fontWeight: "500",
    letterSpacing: "0.3px",
  },
  logoutContainer: {
    padding: "20px 0",
    borderTop: "1px solid rgba(141, 110, 99, 0.1)",
  },
  mainContent: {
    flex: 1,
    backgroundColor: "#faf8f6",
    padding: "30px",
    overflow: "auto",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "30px",
    animation: "fadeIn 0.5s ease-out",
  },
  pageTitle: {
    flex: 1,
  },
  organizationName: {
    fontSize: "28px",
    fontWeight: "600",
    color: "#6d4c41",
    margin: "0 0 5px 0",
    letterSpacing: "0.5px",
  },
  welcomeText: {
    fontSize: "16px",
    color: "#a18072",
    margin: 0,
    fontWeight: "400",
  },
  userInfo: {
    display: "flex",
    alignItems: "center",
  },
  notification: {
    position: "relative",
    marginRight: "25px",
    cursor: "pointer",
  },
  notificationIcon: {
    fontSize: "20px",
    color: "#8d6e63",
  },
  notificationBadge: {
    position: "absolute",
    top: "-8px",
    right: "-8px",
    backgroundColor: "#c94b32",
    color: "white",
    fontSize: "11px",
    fontWeight: "bold",
    width: "18px",
    height: "18px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  userProfile: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
  },
  userAvatar: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    backgroundColor: "#8d6e63",
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "bold",
    fontSize: "18px",
    marginRight: "10px",
  },
  userDetails: {
    textAlign: "left",
  },
  userName: {
    fontSize: "15px",
    fontWeight: "500",
    color: "#6d4c41",
    margin: "0 0 2px 0",
  },
  userRole: {
    fontSize: "13px",
    color: "#a18072",
    margin: 0,
  },
  dashboardContent: {
    animation: "fadeIn 0.6s ease-out",
  },
  statCards: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: "20px",
    marginBottom: "30px",
  },
  statCard: {
    backgroundColor: "white",
    borderRadius: "8px",
    padding: "20px",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.05)",
    transition: "all 0.3s ease",
    border: "1px solid rgba(141, 110, 99, 0.1)",
  },
  statTitle: {
    fontSize: "15px",
    color: "#a18072",
    margin: "0 0 10px 0",
    fontWeight: "500",
  },
  statValue: {
    fontSize: "28px",
    fontWeight: "bold",
    color: "#6d4c41",
    margin: "0 0 5px 0",
  },
  statInfo: {
    fontSize: "13px",
    color: "#a18072",
    margin: 0,
  },
  recentActivity: {
    backgroundColor: "white",
    borderRadius: "8px",
    padding: "20px",
    marginBottom: "30px",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.05)",
    border: "1px solid rgba(141, 110, 99, 0.1)",
  },
  sectionTitle: {
    fontSize: "18px",
    fontWeight: "600",
    color: "#6d4c41",
    margin: "0 0 20px 0",
    letterSpacing: "0.3px",
  },
  activityList: {
    display: "flex",
    flexDirection: "column",
  },
  activityItem: {
    display: "flex",
    padding: "15px 0",
    borderBottom: "1px solid rgba(141, 110, 99, 0.1)",
  },
  activityTime: {
    width: "100px",
    fontSize: "14px",
    color: "#a18072",
    fontWeight: "500",
  },
  activityDetails: {
    flex: 1,
  },
  activityAction: {
    fontSize: "15px",
    color: "#6d4c41",
    margin: "0 0 3px 0",
    fontWeight: "500",
  },
  activityInfo: {
    fontSize: "13px",
    color: "#a18072",
    margin: 0,
  },
  quickActions: {
    backgroundColor: "white",
    borderRadius: "8px",
    padding: "20px",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.05)",
    border: "1px solid rgba(141, 110, 99, 0.1)",
  },
  actionButtons: {
    display: "flex",
    gap: "15px",
    flexWrap: "wrap",
  },
  actionButton: {
    display: "flex",
    alignItems: "center",
    padding: "12px 20px",
    backgroundColor: "#f0e6d9",
    color: "#6d4c41",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    transition: "all 0.2s ease",
    fontFamily: "'Cormorant Garamond', 'Playfair Display', serif",
    fontWeight: "500",
    fontSize: "14px",
  },
  actionIcon: {
    marginRight: "10px",
    fontSize: "16px",
  },
  actionText: {
    letterSpacing: "0.3px",
  },
};

// Insert the CSS keyframes
document.head.appendChild(document.createElement('style')).textContent = keyframes;

export default OrgDashboard;